import React from "react";

import { ClinicBasicForm } from './form/ClinicBasicForm';
import { ClinicServiceForm } from './form/ClinicServiceForm';

export const ClinicEdit = (props) => {
  const { init_clinic, options, init_clinic_services } = props;

  return (
    <>
      <ClinicBasicForm init_clinic={init_clinic} />
      <ClinicServiceForm init_clinic_services={init_clinic_services} options={options}  />
    </>
  );
};